import { Tooltip } from 'devextreme-react';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import api from '../../../services/api-configuration';

const TransferStatusIndicator = React.memo(({
    warehouseIds = [],
    toWarehouseIds = [],
    trueWarehouseIds = [],
    brands = [],
    customsClearance = true,
    pdiExit = false
}) => {
    const [transferCount, setTransferCount] = useState(0);
    const [errorType, setErrorType] = useState(null); // null, 'connection', 'api'
    const intervalRef = useRef(null);

    const fetchTransferCount = useCallback(async () => {
        const body = {
            from_warehouse_id: [],
            to_warehouse_id: [],
            true_warehouse_id: [],
            brand: [],
            customs_clearance: true,
            pdi_exit: false
        };

        try {
            const response = await api.post("/getEligibleTransfersCount", body);
            const count = response?.data?.count || 0;
            setTransferCount(count);
            setErrorType(null); // Başarılı istek sonrası hata durumunu temizle
        } catch (error) {
            console.error("Transfer count fetch error:", error);
            // Servis bağlantı sorunu kontrolü
            const isConnectionError = 
                error.code === 'ERR_NETWORK' || 
                error.message?.includes('Network Error') ||
                error.message?.includes('timeout') ||
                !error.response;
            
            setErrorType(isConnectionError ? 'connection' : 'api');
            setTransferCount(0);
        }
    }, []);

    useEffect(() => {
        // İlk yüklemede çağır
        fetchTransferCount();

        // 5 saniyede bir çağır
        intervalRef.current = setInterval(() => {
            fetchTransferCount();
        }, 5000);

        // Cleanup
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [fetchTransferCount]);

    const hasTransfer = transferCount > 0;

    // Renk belirleme: Servis bağlantı sorunu -> Kırmızı, Transfer Var -> Turuncu, Transfer Yok -> Yeşil
    let indicatorColor, textColor, shadowColor, statusText;
    if (errorType === 'connection') {
        indicatorColor = '#dc3545';
        textColor = '#dc3545';
        shadowColor = 'rgba(220, 53, 69, 0.7)';
        statusText = 'Bağlantı Hatası';
    } else if (errorType === 'api') {
        indicatorColor = '#fd7e14';
        textColor = '#fd7e14';
        shadowColor = 'rgba(253, 126, 20, 0.7)';
        statusText = 'Hata';
    } else if (hasTransfer) {
        indicatorColor = '#fd7e14';
        textColor = '#fd7e14';
        shadowColor = 'rgba(253, 126, 20, 0.7)';
        statusText = 'Transfer Var';
    } else {
        indicatorColor = '#28a745';
        textColor = '#28a745';
        shadowColor = 'rgba(40, 167, 69, 0.6)';
        statusText = 'Transfer Yok';
    }

    return (
        <div
            id="transfer-status-indicator"
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                position: 'relative'
            }}
        >
            <div
                style={{
                    width: (errorType || hasTransfer) ? '10px' : '8px',
                    height: (errorType || hasTransfer) ? '10px' : '8px',
                    borderRadius: '50%',
                    backgroundColor: indicatorColor,
                    animation: (errorType || hasTransfer) ? 'blink 1s infinite' : 'blink 1.5s infinite',
                    boxShadow: `0 0 ${(errorType || hasTransfer) ? '6px' : '4px'} ${shadowColor}`,
                    flexShrink: 0
                }}
            />
            <span style={{
                fontSize: '12px',
                fontWeight: (errorType || hasTransfer) ? '600' : '500',
                color: textColor,
                whiteSpace: 'nowrap',
                letterSpacing: '0.3px'
            }}>
                {statusText}
            </span>
            {(hasTransfer || errorType) && (
                <Tooltip
                    target="#transfer-status-indicator"
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                >
                    <div style={{ padding: '4px' }}>
                        {errorType === 'connection'
                            ? 'Servis bağlantı sorunu var'
                            : errorType === 'api'
                            ? 'Hata oluştu'
                            : `${transferCount} transfer emri var`
                        }
                    </div>
                </Tooltip>
            )}
            <style>{`
                @keyframes blink {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.4; }
                }
            `}</style>
        </div>
    );
});

TransferStatusIndicator.displayName = 'TransferStatusIndicator';

export default TransferStatusIndicator;

